import { gql } from '@apollo/client'

export const GET_COMPANY_LINES_AUTOCOMPLETE = gql`
  query GetCompanyLinesAutocomplete($input: CompanyLinesAutocompleteInput) {
    companyLinesAutocomplete(input: $input) {
      id
      name
    }
  }
`

export const GET_LINES_BY_COMPANY = gql`
  query GetLinesByCompany($limit: Int, $companyId: ID) {
    companyLines(input: { limit: $limit, companyID: $companyId }) {
      id
      name
    }
  }
`
